module.exports = __webpack_public_path__ + "static/media/deposito.012333c6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/modelo/deposito.svg
// module id = 193
// module chunks = 0